import type { JourneyPlanningRecord } from '@wundo/shared/journey.ts';

/** Which journeys the list shows. `action_required` is the "who is behind" overview. */
export type JourneyFilter = 'all' | 'running' | 'action_required' | 'done' | 'stopped';

export const JOURNEY_FILTERS: readonly { value: JourneyFilter; label: string }[] = [
  { value: 'all', label: 'All journeys' },
  { value: 'running', label: 'Running' },
  { value: 'action_required', label: 'Action required' },
  { value: 'done', label: 'Done' },
  { value: 'stopped', label: 'Stopped' },
];

export function isJourneyFilter(value: unknown): value is JourneyFilter {
  return JOURNEY_FILTERS.some((filter) => filter.value === value);
}

/* Behind is a running journey with a step past its deadline and nothing linked. */
export function matchesJourneyFilter(
  journey: JourneyPlanningRecord,
  filter: JourneyFilter,
): boolean {
  if (filter === 'all') return true;
  if (filter === 'action_required') {
    return (
      journey.status === 'running' &&
      journey.steps.some((step) => step.status === 'action_required')
    );
  }
  return journey.status === filter;
}
